import {apiClient} from 'core/apiClient';
import {DocumentReturnGoodsData, ReturnGoodsDictionaryResponse} from 'types';

export async function fetchReturnGoodsDictionary(): Promise<ReturnGoodsDictionaryResponse> {
    return (
        await apiClient.get<ReturnGoodsDictionaryResponse>('/marking/dictionary/return-goods', {
            baseURL: '/api/v2',
        })
    ).data;
}

export async function fetchDocumentReturnGoodsCreate(params: DocumentReturnGoodsData) {
    return (
        await apiClient.post<{reportId: string}>('/marking/return-goods', params, {
            baseURL: '/api/v2',
        })
    ).data;
}

export async function submitDocumentReturnGoods(payload: {
    reportId: string;
    storageLocation: number;
}) {
    const {reportId, storageLocation} = payload;
    return (
        await apiClient.patch<{reportId: string}>(
            `/marking/return-goods/${reportId}/submit`,
            {
                storageLocation,
            },
            {
                baseURL: '/api/v2',
            },
        )
    ).data;
}
